import { Tooltip, Typography } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { getStrokeAndText } from "../projectanalysis/utils";

// Tag as a soft pill with a colour dot; size: "small" (item cards), "default" (table), "large" (tag header).
// `suffix` renders inside the pill after the name (e.g. the tag switcher's dropdown arrow).
// `onRemove` adds a small × button. Hovering shows the tag's AI context, like TagItem; pass `tooltip`
// to show other text, or `tooltip={false}` where the context is already on screen.
export default function TagPill({ tag, size = "default", suffix = null, onRemove = null, tooltip = undefined }) {
  const { color = "#cccccc", emoji = "", tag: name = "", ai_context = null, is_deleted = false, is_demo = false, workspace_id } = tag || {};
  const { stroke } = getStrokeAndText(color);
  // "0"/"1" is accepted as well as a boolean. Only a deleted workspace tag is faded: global tags (workspace_id
  // null) in a tag list are demo-study tags, stored deleted to keep them out of pickers
  const deleted = (is_deleted === true || Number(is_deleted) === 1) && !is_demo && workspace_id !== null;
  const tooltipTitle = tooltip === undefined ? ai_context : tooltip;

  const pill = (
    <span
      className={`manage-tag-pill manage-tag-pill-${size} ${deleted ? "opacity-06" : ""}`}
      style={{ backgroundColor: `${color}33`, borderColor: `${stroke}66` }}
    >
      {emoji ? (
        <span className='manage-tag-emoji'>{emoji}</span>
      ) : (
        <span className='manage-tag-dot' style={{ backgroundColor: color, borderColor: stroke }} />
      )}
      <Typography.Text ellipsis className='color-121217'>
        {name}
      </Typography.Text>
      {suffix}
      {onRemove && (
        <button
          type='button'
          aria-label={`Remove ${name}`}
          className='manage-tag-remove'
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onRemove(e);
          }}
        >
          <CloseOutlined />
        </button>
      )}
    </span>
  );

  return tooltipTitle ? <Tooltip title={tooltipTitle}>{pill}</Tooltip> : pill;
}
